var App = App || {};

App.Masthead = (function ($) {
    "use strict";

    function Init(selector) {
        if (selector.length) {
            selector.each(function () {
                var $this = $(this),
                    $title = $this.find(".h1"),
                    $titleStrong = $title.find("strong");

                let titleRotatingText = typeof TitleData !== "undefined" ? [...TitleData.TitleRotatingText] : [];

                if (titleRotatingText.length) {
                    var titleAriaLabel = $title.text().replace(titleRotatingText[0], titleRotatingText.toString().replaceAll(",", ", "));

                    $title.attr("aria-label", titleAriaLabel);
                    $titleStrong.text(titleRotatingText);

                    setTimeout(function () {
                        calculateTitleRotatingTextWidth(titleRotatingText, $titleStrong);
                    }, 1);

                    $(window).on("load resize orientationchange", function () {
                        setTimeout(function () {
                            calculateTitleRotatingTextWidth(titleRotatingText, $titleStrong);
                        }, 1);
                    });

                    $titleStrong.Morphext({
                        animation: "",
                        complete: function () {
                            var phrases = this.phrases.length - 1,
                                index = this.index;

                            $titleStrong.removeClass("hide");

                            if (index < phrases) {
                                setTimeout(function () {
                                    $titleStrong.addClass("hide");
                                }, 1466);
                            }

                            if (index == phrases) {
                                this.stop();
                            }
                        },
                        speed: 1666
                    });
                }
            });
        }
    }

    function calculateTitleRotatingTextWidth(titleRotatingText, $titleStrong) {
        const tempSpan = document.createElement("span");

        tempSpan.style.position = "absolute";
        tempSpan.style.visibility = "hidden";
        tempSpan.style.whiteSpace = "nowrap";

        const computedStyle = getComputedStyle($titleStrong[0]);

        tempSpan.style.font = computedStyle.font;
        tempSpan.style.fontWeight = computedStyle.fontWeight;
        tempSpan.style.letterSpacing = computedStyle.letterSpacing;

        document.body.appendChild(tempSpan);

        let maxWidth = 0;

        titleRotatingText.forEach(word => {
            tempSpan.textContent = word;

            const width = tempSpan.getBoundingClientRect().width;

            if (width > maxWidth) {
                maxWidth = width;
            }
        });

        document.body.removeChild(tempSpan);

        $titleStrong[0].style.width = `${Math.ceil(maxWidth)}px`;
    }

    return {
        Init: Init
    };
})(jQuery);